import { useState, useEffect } from 'react'
import galleryCoverLencois from '@/assets/gallery-cover-lencois.webp'
import galleryCoverAlexandra from '@/assets/gallery-cover-alexandra.webp'
import galleryCoverCosta from '@/assets/gallery-cover-costa.webp'
import galleryCoverEnzo from '@/assets/gallery-cover-enzo.webp'
import galleryCoverVenice from '@/assets/gallery-cover-venice.webp'
import galleryCoverGiulia from '@/assets/gallery-cover-giulia.webp'
import galleryCoverParis from '@/assets/gallery-cover-paris.webp'
import magnifiqueGiuliaNew1 from '@/assets/magnifique-giulia-new-1.webp'
import magnifiqueGiuliaNew2 from '@/assets/magnifique-giulia-new-2.webp'
import magnifiqueGiuliaNew3 from '@/assets/magnifique-giulia-new-3.webp'
import magnifiqueGiuliaNew4 from '@/assets/magnifique-giulia-new-4.webp'
import magnifiqueGiuliaNew5 from '@/assets/magnifique-giulia-new-5.webp'
import costaNew1 from '@/assets/costa-new-1.webp'
import costaNew2 from '@/assets/costa-new-2.webp'
import costaNew3 from '@/assets/costa-new-3.webp'
import costaNew4 from '@/assets/costa-new-4.webp'
import parisNew1 from '@/assets/paris-new-1.webp'
import parisNew2 from '@/assets/paris-new-2.webp'
import parisNew3 from '@/assets/paris-new-3.webp'
import parisNew4 from '@/assets/paris-new-4.webp'
import parisNew5 from '@/assets/paris-new-5.webp'
import parisNew6 from '@/assets/paris-new-6.webp'
import lencoisNew1 from '@/assets/lencois-new-1.webp'
import lencoisNew2 from '@/assets/lencois-new-2.webp'
import lencoisNew3 from '@/assets/lencois-new-3.webp'
import lencoisNew4 from '@/assets/lencois-new-4.webp'
import enzoNew1 from '@/assets/enzo-new-1.webp'
import enzoNew2 from '@/assets/enzo-new-2.webp'
import enzoNew3 from '@/assets/enzo-new-3.webp'
import enzoNew4 from '@/assets/enzo-new-4.webp'
import alexandraNew1 from '@/assets/alexandra-new-1.webp'
import alexandraNew2 from '@/assets/alexandra-new-2.webp'
import alexandraNew3 from '@/assets/alexandra-new-3.webp'
import alexandraNew4 from '@/assets/alexandra-new-4.webp'
import alexandraNew5 from '@/assets/alexandra-new-5.webp'
import virtuoseVeniceNew1 from '@/assets/virtuose-venice-new-1.webp'
import virtuoseVeniceNew2 from '@/assets/virtuose-venice-new-2.webp'
import virtuoseVeniceNew3 from '@/assets/virtuose-venice-new-3.webp'
import virtuoseVeniceNew4 from '@/assets/virtuose-venice-new-4.webp'
import virtuoseVeniceNew5 from '@/assets/virtuose-venice-new-5.webp'
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@/components/ui/carousel'
import { Dialog, DialogContent } from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import {
  ChevronLeft,
  ChevronRight,
  X,
  ArrowLeft,
  ArrowRight,
  Loader2,
} from 'lucide-react'
import { useScrollAnimation } from '@/hooks/use-scroll-animation'

const GallerySection = () => {
  const { ref, isVisible } = useScrollAnimation()
  const [selectedImageIndex, setSelectedImageIndex] = useState<number | null>(
    null,
  )
  const [currentImageInCategory, setCurrentImageInCategory] = useState(0)
  const [dialogOpen, setDialogOpen] = useState(false)
  const [api, setApi] = useState<any>()
  const [current, setCurrent] = useState(0)
  const [isHovered, setIsHovered] = useState(false)
  const [touchStart, setTouchStart] = useState<number | null>(null)
  const [touchEnd, setTouchEnd] = useState<number | null>(null)
  const [swipeOffset, setSwipeOffset] = useState(0)
  const [isImageLoading, setIsImageLoading] = useState(false)

  // Lençóis Maranhenses images
  const lencoisSet = [lencoisNew1, lencoisNew2, lencoisNew3, lencoisNew4]

  // Placeholder images from Unsplash for each carousel (8 additional images each)
  const placeholderSets = [
    // Set 2 - Graduation themed
    [
      'https://images.unsplash.com/photo-1523050854058-8df90110c9f1?w=800',
      'https://images.unsplash.com/photo-1627556704302-624286467c65?w=800',
      'https://images.unsplash.com/photo-1564585222527-c2777a5bc6cb?w=800',
      'https://images.unsplash.com/photo-1541339907198-e08756dedf3f?w=800',
      'https://images.unsplash.com/photo-1607237138185-eedd9c632b0b?w=800',
      'https://images.unsplash.com/photo-1560343776-97e7d202ff0e?w=800',
      'https://images.unsplash.com/photo-1555854877-bab0e564b8d5?w=800',
      'https://images.unsplash.com/photo-1517486808906-6ca8b3f04846?w=800',
    ],
    // Set 3 - Costa Amalfitana
    [costaNew1, costaNew2, costaNew3, costaNew4],
    // Set 4 - Enzo
    [enzoNew1, enzoNew2, enzoNew3, enzoNew4],
    // Set 5 - Marathon/Sports themed
    [
      'https://images.unsplash.com/photo-1571902943202-507ec2618e8f?w=800',
      'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=800',
      'https://images.unsplash.com/photo-1594911772125-07fc7a2d8d9f?w=800',
      'https://images.unsplash.com/photo-1547483238-f400e65ccd56?w=800',
      'https://images.unsplash.com/photo-1517838277536-f5f99be501cd?w=800',
      'https://images.unsplash.com/photo-1540558876260-e82d1f8c3e0c?w=800',
      'https://images.unsplash.com/photo-1584735935682-2f2b69dff9d2?w=800',
      'https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=800',
    ],
    // Set 6 - Graduation/Celebration themed
    [
      'https://images.unsplash.com/photo-1562774053-701939374585?w=800',
      'https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=800',
      'https://images.unsplash.com/photo-1492684223066-81342ee5ff30?w=800',
      'https://images.unsplash.com/photo-1519671482749-fd09be7ccebf?w=800',
      'https://images.unsplash.com/photo-1496024840928-4c417adf211d?w=800',
      'https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?w=800',
      'https://images.unsplash.com/photo-1529543544277-8c5a1c4b73be?w=800',
      'https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?w=800',
    ],
    // Set 7 - Paris/Versalhes
    [parisNew1, parisNew2, parisNew3, parisNew4, parisNew5, parisNew6],
  ]

  const galleryItems = [
    {
      id: 1,
      images: [galleryCoverLencois, ...lencoisSet],
    },
    {
      id: 2,
      images: [
        galleryCoverAlexandra,
        alexandraNew1,
        alexandraNew2,
        alexandraNew3,
        alexandraNew4,
        alexandraNew5,
      ],
    },
    {
      id: 3,
      images: [galleryCoverCosta, costaNew1, costaNew2, costaNew3, costaNew4],
    },
    {
      id: 4,
      images: [galleryCoverEnzo, ...placeholderSets[2]],
    },
    {
      id: 5,
      images: [
        galleryCoverVenice,
        virtuoseVeniceNew1,
        virtuoseVeniceNew2,
        virtuoseVeniceNew3,
        virtuoseVeniceNew4,
        virtuoseVeniceNew5,
      ],
    },
    {
      id: 6,
      images: [
        galleryCoverGiulia,
        magnifiqueGiuliaNew1,
        magnifiqueGiuliaNew2,
        magnifiqueGiuliaNew3,
        magnifiqueGiuliaNew4,
        magnifiqueGiuliaNew5,
      ],
    },
    {
      id: 7,
      images: [galleryCoverParis, ...placeholderSets[5]],
    },
  ]

  const handlePreviousCategory = () => {
    if (selectedImageIndex !== null) {
      setSelectedImageIndex(
        (selectedImageIndex - 1 + galleryItems.length) % galleryItems.length,
      )
      setCurrentImageInCategory(0)
    }
  }

  const handleNextCategory = () => {
    if (selectedImageIndex !== null) {
      setSelectedImageIndex((selectedImageIndex + 1) % galleryItems.length)
      setCurrentImageInCategory(0)
    }
  }

  const handlePreviousImage = () => {
    if (selectedImageIndex !== null) {
      const item = galleryItems[selectedImageIndex]
      setIsImageLoading(true)
      setCurrentImageInCategory(
        prev => (prev - 1 + item.images.length) % item.images.length,
      )
    }
  }

  const handleNextImage = () => {
    if (selectedImageIndex !== null) {
      const item = galleryItems[selectedImageIndex]
      setIsImageLoading(true)
      setCurrentImageInCategory(prev => (prev + 1) % item.images.length)
    }
  }

  const handleImageClick = (index: number) => {
    setSelectedImageIndex(index)
    setCurrentImageInCategory(0)
    setIsImageLoading(true)
    setDialogOpen(true)
  }

  // Touch handlers for swipe navigation
  const minSwipeDistance = 50

  const onTouchStart = (e: React.TouchEvent) => {
    setTouchEnd(null)
    setTouchStart(e.targetTouches[0].clientX)
  }

  const onTouchMove = (e: React.TouchEvent) => {
    setTouchEnd(e.targetTouches[0].clientX)
    if (touchStart) {
      const offset = e.targetTouches[0].clientX - touchStart
      setSwipeOffset(offset)
    }
  }

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) {
      setSwipeOffset(0)
      return
    }

    const distance = touchStart - touchEnd
    const isLeftSwipe = distance > minSwipeDistance
    const isRightSwipe = distance < -minSwipeDistance

    if (selectedImageIndex !== null) {
      const currentItem = galleryItems[selectedImageIndex]

      if (isLeftSwipe) {
        if (currentItem.images.length > 1) {
          handleNextImage()
        } else {
          handleNextCategory()
        }
      }

      if (isRightSwipe) {
        if (currentItem.images.length > 1) {
          handlePreviousImage()
        } else {
          handlePreviousCategory()
        }
      }
    }

    setSwipeOffset(0)
    setTouchStart(null)
    setTouchEnd(null)
  }

  // Carousel API
  useEffect(() => {
    if (!api) return

    setCurrent(api.selectedScrollSnap())

    api.on('select', () => {
      setCurrent(api.selectedScrollSnap())
    })
  }, [api])

  // Autoplay
  useEffect(() => {
    if (!api || isHovered) return

    const intervalId = setInterval(() => {
      api.scrollNext()
    }, 4000)

    return () => clearInterval(intervalId)
  }, [api, isHovered])

  // Keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (dialogOpen && selectedImageIndex !== null) {
        const currentItem = galleryItems[selectedImageIndex]
        if (e.key === 'ArrowLeft') {
          if (currentItem.images.length > 1) {
            handlePreviousImage()
          } else {
            handlePreviousCategory()
          }
        } else if (e.key === 'ArrowRight') {
          if (currentItem.images.length > 1) {
            handleNextImage()
          } else {
            handleNextCategory()
          }
        } else if (e.key === 'Escape') {
          setDialogOpen(false)
        }
      }
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [dialogOpen, selectedImageIndex, currentImageInCategory])

  const currentItem =
    selectedImageIndex !== null ? galleryItems[selectedImageIndex] : null

  return (
    <section className="py-24 bg-gradient-to-b from-background via-muted/10 to-background">
      <div
        ref={ref}
        className={`container mx-auto px-4 transition-all duration-700 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}
      >
        <div className="text-center mb-12">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-foreground mb-3">
            Galeria de <span className="text-gold italic">Inspiração</span>
          </h2>
          <p className="text-muted-foreground mb-8 max-w-3xl mx-auto leading-relaxed text-base">
            Suas histórias acompanham os diferentes momentos da vida:
            celebrações em família, viagens, formaturas, casamentos, conquistas,
            maratonas... Momentos marcantes e alegrias do dia a dia. Todas essas
            memórias merecem um destino especial, pensado para preservá-las com
            sofisticação e cuidado. Aqui, cada história encontra seu álbum.
          </p>
        </div>

        <div
          className="relative"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <Carousel
            setApi={setApi}
            opts={{
              align: 'start',
              loop: true,
            }}
            className="w-full max-w-7xl mx-auto"
          >
            <CarouselContent className="-ml-2 md:-ml-4">
              {galleryItems.map((item, index) => (
                <CarouselItem
                  key={item.id}
                  className="pl-2 md:pl-4 basis-full sm:basis-1/2 lg:basis-1/3 xl:basis-1/4"
                >
                  <div
                    className="group relative overflow-hidden rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer h-full"
                    onClick={() => handleImageClick(index)}
                  >
                    <div className="h-96 overflow-hidden">
                      <img
                        src={item.images[0]}
                        alt={`Álbum ${index + 1}`}
                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                        loading="lazy"
                      />
                    </div>
                    {item.images.length > 1 && (
                      <div className="absolute top-4 right-4 bg-black/60 text-white px-3 py-1 rounded-full text-sm font-semibold backdrop-blur-sm">
                        +{item.images.length - 1}
                      </div>
                    )}
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>

            <CarouselPrevious className="absolute -left-4 md:-left-12 top-1/2 -translate-y-1/2 h-12 w-12 bg-primary hover:bg-primary/90 text-primary-foreground border-none shadow-lg" />
            <CarouselNext className="absolute -right-4 md:-right-12 top-1/2 -translate-y-1/2 h-12 w-12 bg-primary hover:bg-primary/90 text-primary-foreground border-none shadow-lg" />
          </Carousel>

          <div className="flex justify-center gap-2 mt-6">
            {galleryItems.map((_, index) => (
              <button
                key={index}
                onClick={() => api?.scrollTo(index)}
                className={`h-2 rounded-full transition-all duration-300 ${
                  index === current
                    ? 'w-8 bg-primary'
                    : 'w-2 bg-muted-foreground/30 hover:bg-muted-foreground/50'
                }`}
                aria-label={`Ir para slide ${index + 1}`}
              />
            ))}
          </div>

          <div className="absolute left-0 top-0 bottom-0 w-20 bg-gradient-to-r from-muted/30 to-transparent pointer-events-none hidden lg:block" />
          <div className="absolute right-0 top-0 bottom-0 w-20 bg-gradient-to-l from-muted/30 to-transparent pointer-events-none hidden lg:block" />
        </div>

        {/* Image Modal Dialog */}
        <Dialog open={dialogOpen} onOpenChange={setDialogOpen}>
          <DialogContent className="max-w-7xl w-[95vw] h-[95vh] p-0 bg-background/95 backdrop-blur-xl border border-border/50 shadow-2xl">
            {currentItem && (
              <div className="relative w-full h-full flex items-center justify-center">
                {currentItem.images.length > 1 && (
                  <>
                    <Button
                      variant="ghost"
                      size="icon"
                      className="absolute left-4 top-1/2 -translate-y-1/2 z-10 bg-primary/80 hover:bg-primary text-primary-foreground rounded-full w-12 h-12 backdrop-blur-sm shadow-lg"
                      onClick={handlePreviousImage}
                    >
                      <ChevronLeft className="h-8 w-8" />
                    </Button>

                    <Button
                      variant="ghost"
                      size="icon"
                      className="absolute right-4 top-1/2 -translate-y-1/2 z-10 bg-primary/80 hover:bg-primary text-primary-foreground rounded-full w-12 h-12 backdrop-blur-sm shadow-lg"
                      onClick={handleNextImage}
                    >
                      <ChevronRight className="h-8 w-8" />
                    </Button>
                  </>
                )}

                <Button
                  variant="ghost"
                  size="icon"
                  className="absolute left-4 bottom-4 z-10 bg-secondary/80 hover:bg-secondary text-secondary-foreground rounded-full w-10 h-10 backdrop-blur-sm shadow-lg"
                  onClick={handlePreviousCategory}
                  title="Categoria anterior"
                >
                  <ArrowLeft className="h-5 w-5" />
                </Button>

                <Button
                  variant="ghost"
                  size="icon"
                  className="absolute right-4 bottom-4 z-10 bg-secondary/80 hover:bg-secondary text-secondary-foreground rounded-full w-10 h-10 backdrop-blur-sm shadow-lg"
                  onClick={handleNextCategory}
                  title="Próxima categoria"
                >
                  <ArrowRight className="h-5 w-5" />
                </Button>

                <Button
                  variant="ghost"
                  size="icon"
                  className="absolute right-4 top-4 z-10 bg-destructive/80 hover:bg-destructive text-destructive-foreground rounded-full w-10 h-10 backdrop-blur-sm shadow-lg"
                  onClick={() => setDialogOpen(false)}
                >
                  <X className="h-6 w-6" />
                </Button>

                <div
                  className="relative w-full h-full flex flex-col items-center justify-center p-4 md:p-8 overflow-hidden"
                  onTouchStart={onTouchStart}
                  onTouchMove={onTouchMove}
                  onTouchEnd={onTouchEnd}
                >
                  {swipeOffset !== 0 && (
                    <div className="absolute inset-0 flex items-center justify-center pointer-events-none z-10">
                      <div
                        className={`flex items-center gap-2 px-6 py-3 rounded-full bg-primary/80 backdrop-blur-sm text-primary-foreground transition-opacity ${
                          Math.abs(swipeOffset) > 30
                            ? 'opacity-100'
                            : 'opacity-0'
                        }`}
                      >
                        {swipeOffset < 0 ? (
                          <>
                            <ArrowLeft className="h-8 w-8" />
                            <span className="text-lg font-semibold">
                              Anterior
                            </span>
                          </>
                        ) : (
                          <>
                            <span className="text-lg font-semibold">
                              Próxima
                            </span>
                            <ArrowRight className="h-8 w-8" />
                          </>
                        )}
                      </div>
                    </div>
                  )}

                  <div
                    className="relative flex items-center justify-center min-h-[50vh]"
                    style={{
                      transform:
                        swipeOffset !== 0
                          ? `translateX(${swipeOffset * 0.3}px)`
                          : 'none',
                      opacity:
                        swipeOffset !== 0
                          ? Math.max(0.5, 1 - Math.abs(swipeOffset) / 300)
                          : 1,
                      transition:
                        swipeOffset === 0 ? 'opacity 0.15s ease-out' : 'none',
                    }}
                  >
                    {isImageLoading && (
                      <div className="absolute inset-0 flex items-center justify-center">
                        <Loader2 className="h-10 w-10 animate-spin text-primary" />
                      </div>
                    )}
                    <img
                      src={currentItem.images[currentImageInCategory]}
                      alt={`Imagem ${currentImageInCategory + 1}`}
                      className={`max-w-full max-h-[75vh] object-contain select-none transition-opacity duration-150 ${isImageLoading ? 'opacity-0' : 'opacity-100'}`}
                      draggable={false}
                      onLoad={() => setIsImageLoading(false)}
                    />
                  </div>

                  {currentItem.images.length > 1 && (
                    <div className="flex justify-center gap-2 mt-4">
                      {currentItem.images.map((_, index) => (
                        <button
                          key={index}
                          onClick={() => setCurrentImageInCategory(index)}
                          className={`h-2 rounded-full transition-all duration-300 ${
                            index === currentImageInCategory
                              ? 'w-8 bg-primary'
                              : 'w-2 bg-muted-foreground/30 hover:bg-muted-foreground/50'
                          }`}
                          aria-label={`Ir para imagem ${index + 1}`}
                        />
                      ))}
                    </div>
                  )}
                </div>
              </div>
            )}
          </DialogContent>
        </Dialog>
      </div>
    </section>
  )
}

export default GallerySection
